import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import {Avatar, Col, Descriptions, Divider, Row} from 'antd';
import {FcCheckmark} from 'react-icons/all';
import {PractitionerContext} from '../PractitionerContext';
import {addressText} from 'utils/Utils';
import {DEFAULT_AVATAR_URL} from 'shared/constants/AppConst';

const PractitionerInfo = () => {
  const intl = useIntl();

  const practitionerContext = useContext(PractitionerContext);
  const {selectedPractitioner} = practitionerContext;

  return (
    <>
      <Row style={{padding: 10, margin: 0}}>
        <Col span={11} />
        <Col span={2}>
          <Avatar
            style={{
              width: '150px',
              height: '150px',
              marginBottom: 10,
            }}
            src={selectedPractitioner?.photoUrl || DEFAULT_AVATAR_URL}
          />
        </Col>
        <Col span={11} />
      </Row>

      <Divider />

      <Descriptions
        bordered
        title={selectedPractitioner?.name}
        size='middle'
        style={{paddingTop: 10}}>
        <Descriptions.Item label={intl.messages['practitioner.name']}>
          {selectedPractitioner?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.enabled']}>
          {selectedPractitioner?.active ? <FcCheckmark /> : <></>}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.idn']}>
          {selectedPractitioner?.idn}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.ppn']}>
          {selectedPractitioner?.ppn}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.phoneNumber']}>
          {selectedPractitioner?.phone}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.email']}>
          {selectedPractitioner?.email}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.birthDate']}>
          {selectedPractitioner?.birthDate}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.gender']}>
          {selectedPractitioner?.gender
            ? intl.messages[
                `common.gender.${selectedPractitioner.gender.toLowerCase()}`
              ]
            : ''}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.nationality']}>
          {selectedPractitioner?.nationality?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.speciality']}>
          {selectedPractitioner?.speciality?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.academicRank']}>
          {selectedPractitioner?.academicRank &&
            intl.messages[
              `practitioner.academicRank.${selectedPractitioner?.academicRank.toLowerCase()}`
            ]}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['practitioner.academicTitle']}>
          {selectedPractitioner?.academicTitle &&
            intl.messages[
              `practitioner.academicTitle.${selectedPractitioner?.academicTitle.toLowerCase()}`
            ]}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['address']}>
          {addressText(selectedPractitioner?.address)}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default PractitionerInfo;
